// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CP","heading":"DP","items":"EP","featureCss":"FP","disabled":"GP","imgCss":"HP"};